var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.3333 10.8889v.6666c0 .3537-.1404.6928-.3905.9429-.25.25-.5892.3905-.9428.3905h-6.66667c-.35362 0-.69276-.1405-.94281-.3905-.25004-.2501-.39052-.5892-.39052-.9429v-4.66662c0-.35363.14048-.69277.39052-.94281.25005-.25005.58919-.39053.94281-.39053h6.66667c.3536 0 .6928.14048.9428.39053.2501.25004.3905.58918.3905.94281v.66666",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 5.55554-1.0351-2.07022c-.03915-.07834-.09334-.1482-.1595-.20559-.06615-.05739-.14296-.10119-.22605-.12888-.08308-.0277-.17081-.03875-.25816-.03253-.08736.00622-.17264.02959-.25096.06878l-4.73689 2.36844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.3333 10.8889c.1768 0 .3464-.0703.4714-.1953.1251-.125.1953-.2946.1953-.4714v-1.99999c0-.17681-.0702-.34638-.1953-.47141-.125-.12502-.2946-.19526-.4714-.19526h-1.6666c-.4421 0-.86598.1756-1.17854.48816-.31257.31256-.48816.73648-.48816 1.17851s.17559.86599.48816 1.17849c.31256.3126.73644.4882 1.17854.4882z",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.6667 9.05554c.0329 0 .0652.00978.0926.02809s.0487.04434.0613.0748c.0127.03045.016.06396.0095.09629-.0064.03233-.0223.06203-.0456.08534s-.053.03918-.0853.04561-.0659.00313-.0963-.00948c-.0305-.01262-.0565-.03398-.0748-.06139-.0183-.0274-.0281-.05963-.0281-.09259 0-.0442.0176-.0866.0488-.11785.0313-.03126.0737-.04882.1179-.04882"
  }))));
}
export default SvgWalletreact;